/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostOptimizationTrend {
    getFixupPrototypeFunction() { return CostOptimizationTrend.fixupPrototype; }

    static newInstance(model: Partial<CostOptimizationTrend>): CostOptimizationTrend {
        let obj = Object.assign(new CostOptimizationTrend(), model);
        CostOptimizationTrend.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostOptimizationTrend>): CostOptimizationTrend {
        if (!model) return null;
        return CostOptimizationTrend.newInstance(<CostOptimizationTrend> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostOptimizationTrend) {
        if (!obj) return;

        models.CostOptimizationTrend.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostOptimizationTrend): boolean {
        Object.setPrototypeOf(obj, CostOptimizationTrend.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost_forecast === undefined) {
            this.cost_forecast = 0;
        }
        if (this.potential_forecasted_cost === undefined) {
            this.potential_forecasted_cost = 0;
        }
        if (this.potential_savings === undefined) {
            this.potential_savings = 0;
        }
        if (typeof this.date === "string") {
            this.date = new Date(<string><any>this.date);
        }
    }

    /**
     * Cloud Provider
     */
    cloud: models.CloudServiceName;

    cost_forecast: number;

    potential_forecasted_cost: number;

    potential_savings: number;

    date: Date;

}
